export enum IRenderStatus {
    start = 0,
    ready = 1,
    fail = 2
}

export interface INewUserPage {
    // 限制分辨率， 3倍图
    background?: BackgroundInfo;
    pageColor?: IPageColor;
    buttonName?: string[];
    ruleUrl?: string;
    // 数据固定, 直接从服务器还是pc
    couponList?: ICoupon[];
    bannerList?: IBannerConf[];
    // 榜单
    rankList?: IRankList[];
    shopList?: IShopList[];
}
export interface IPageColor {
    // 倒计时，颜色 + rule颜色
    countTimeBackColor: string;
    countTimeColor: string;
    // 倒计时悬浮状态颜色
    countTimeFixedBackColor: string;
    countTimeFixedColor: string;
    // 悬浮状态的背景颜色
    couponFixedBackColor: string;
    // 优惠券颜色配置
    // 优惠券顶部Banner颜色
    couponButtonTxtColor: string;
    // 优惠券颜色
    couponTxtColor: string;
    // 优惠券背景色 & 活动状态button按钮颜色
    couponBackColor: string;
    // 非激活状态颜色
    couponUnActiveBackColor: string;
    // 页面背景颜色， 采用 background的topBackColor[0]
    // htmlBackColor: string;
}
// 是否提供
export interface BackgroundInfo {
    headerImg?: string;
    // 买家页面渐变色
    topBackColor?: string[];
    // 卖家页面渐变色
    sellerTopBackColor?: string[];
    couponImg?: string;
    feedBackColor?: string[];
    // 卖家标题图像
    sellerTitleImg?: string;
    sellerTitleText?: string;
}

export enum IUserType {
    buyer = 1,
    seller = 2,
    all = 0,
    none = -1
}

export enum ICouponType {
    // 满减券
    direct = 1,
    // 包邮券
    shipping = 2,
}

export enum ICouponState {
    valid = 1,
    invalid = 2,
}

export interface IButtonName {
    name: string;
    type: IUserType;
}
// 数据获取，
export interface ICoupon extends CouponInfoModleList{
    id: number;
    // 接口返回，pc
    name: string;
    desc: string;
    // 满多少钱，后端返回
    limitAmount: number;
    // 减多少钱 满xxxxx减去xx
    deductionAmount?: number;
    // 类型： 买家、卖家
    type: IUserType;
    ownerType?: IUserType;
}

export interface ICouponParams {
    countryCode: string;
    // currencyCode: string;
    language: string;
    // 1:新人专项 2:全量用户 3:新人礼包
    marketingType: number;
    uid?: number;
    uniqueMark: string;
    cookieToken?: string;
}

export interface ICouponResponse {
    expireTime: number;
    marketingId: number;
    // 1 领取成功(包括已领取)；2 非新用户；3 已过期 4 未登录 5 已领完 6 已领取
    // H5List接口：1. 可领取
    state: number;
    // 未登录用户的过期时间
    countDownExpireTime?: number,
    data?: CouponInfoModleList[];
    couponInfoModleList?: CouponInfoModleList[];
    couponTemplateList?: CouponInfoModleList[];
    drawUserIdentity?: {
        newBuyer: boolean
        newSeller: boolean
        regionOpenBuyer: boolean
        regionOpenSeller: boolean
    }
    // couponInfoModleList: CouponInfoModleList[];
}

export interface CouponInfoModleList {
    couponCode?: string;
    couponState?: ICouponState;
    couponType?: ICouponType;
    // 抵扣金额
    deductionAmount?: number;
    expireTime?: number;
    startTime?: number;
    // 券副标题-优惠信息
    subTitle?: string;
    // 即ID
    templateId?: number;
    title?: string;
    // 不可用原因：1.已过期；2.已使用
    unUserReason?: string;
    // 可使用标识：1.未到使用时间；2.可以使用
    useFlag?: number;
    userCatgoryInfo?: string;
    limitAmount?: number;
    // 有效期
    validityTime?: string;
}
// 缺省展示，有img展示img
export interface IBannerConf {
    title?: string;
    color?: string;
    url?: string;
    img?: string;
    // 类型： 买家、卖家
    type?: IUserType;
}

// 新人榜、销售榜、
//  /adapter/center/oversea/top/v1/list
export interface IRankList {
    url: string
}

export interface IShopList {
    title: number;
    feedIds: number[];
}

export interface IState extends INewUserPage{
    // 负责当前用户的选择渲染状态， renderStatus是为了方便操作做的
    renderStatus: IRenderStatus;
    // 当前用户的实际状态
    userType?: IUserType;
    renderUserType?: IUserType;
    // 超时时间
    expiredTime: number;
    // 是否过期
    expired?: boolean;
    // 商品流数据
    sellerTabList: Array<any>;
    buyerTabList: Array<any>;
    background: BackgroundInfo,
    tabBgColor?: string
    tabTextColorActive?: string
    tabTextColor?: string
    tabCount?: number
    tabItemTitleBg?: string
    couponStatus?: number
}

export enum ListTypeEnum {
    up = 1, // 飙升榜
    sale = 2, // 销量榜
    news = 3, // 新品榜
}

export enum ListTypeNameEnum {
    up = 'up', // 飙升榜
    sale = 'sale', // 销量榜
    news = 'news', // 新品榜
}

export const ListTypeMap = {
    [ListTypeEnum.sale]: ListTypeNameEnum.sale,
    [ListTypeEnum.news]: ListTypeNameEnum.news,
    [ListTypeEnum.up]: ListTypeNameEnum.up,
}

export interface ListType {
    sale: string
    news: string
    up: string
}

export interface CategoryItemType {
    key: number
    id?: number
    title: string
}

export type SelectItemProps<T = any> = {
    id: T
    timeRange: any
}

export enum TimeTypeEnum {
    hour24 = 1,
    day7 = 2,
}

export interface ListItemConfig {
    topBgImg: string
}

export interface ListReqType {
    countryCode: string
    currencyCode: string
    language: string
    // 1:飙升榜;2:销量榜;3:新品榜
    listType: ListTypeEnum
    // 1:过去24多小时;2:近7天
    timeType: TimeTypeEnum
}

export interface ProductItemType {
    /**
     * 主图
     */
    spuLogoUrl?: string
    /**
     * 热值
     */
    topIndex?: string
    /**
     * 最低价
     */
    price?: number
    /**
     * 热值前缀
     */
    topIndexDes?: string
    /**
     * 尺码
     */
    spuSize?: string
    /**
     * skuId
     */
    skuId?: number
    /**
     * spuId
     */
    spuId?: number
    /**
     * 名字
     */
    spuName?: string
}

export interface ListResType {
    /**
     * 正确响应时该值为 Result#SUCCESS_CODE，错误响应时为错误代码
     */
    code?: number
    /**
     * 正确响应时该值会被使用
     */
    data: {
      spuList: ProductItemType[]
      moreTopList: any[]
    }
    /**
     * 正确响应时该值为 Result#DEFAULT_SUCCESS_MESSAGE，错误响应时为错误信息
     */
    msg?: string
    status: number
}


export interface MoreTopList{
    // 商品品牌
    brandName: string;
    // 类目id
    categoryId: number;
    // 类目名称
    categoryName: string;
    // 商品Id
    spuId: number;
    spuLogoUrl: string;
    spuName: number;
    topId: number;
    topIndex: number;
    topIndexDes: string;
    topName: string;
}

export interface HomeRankListResponse {
    topList: RankList[]
}

export interface RankList {
    topId: number;
    topName: string;
    topSubName: string;
    topType: number;
    spuList: ProductItemType[]
}
